import angular from "angular";
import dotsFilter from './dots.filter';

let dotsModule = angular.module('dots.filter', [])
.filter('dots', dotsFilter)

.name;

export default dotsModule;



// WEBPACK FOOTER //
// ./client/app/common/filters/dotsFilter/dots.js